import "./App.css";
import "scss/index.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-phone-number-input/style.css";
import "react-quill/dist/quill.snow.css";

import Lottie from "react-lottie";
import { LoadingAnimation } from "asset/animations";
import { useAppContext } from "contexts";
import { AppRoutes } from "routes";

import Geocode from "react-geocode";

const WithGeocode = () => {
  Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
  Geocode.enableDebug();
};

export { WithGeocode };

function App() {
  const { isLoading } = useAppContext();
  const animationOption = {
    loop: true,
    autoplay: true,
    animationData: LoadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      {isLoading ? (
        <div
          className="flex-row align-items-center justify-content-center "
          style={{ minHeight: "100vh" }}
        >
          <Lottie options={animationOption} height={300} width={300} />
        </div>
      ) : (
        <AppRoutes />
      )}
    </>
  );
}

export default App;
